export default "__VITE_ASSET__Gchkn9me__"